import { DescriptionFormatter } from '@cian/start-chat-widget';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { getAgentAvailability, offerSelector } from '../../selectors';
import { concatPhones } from '../../utils/phone';
import * as styles from './index.css';

export function ChatDescriptionContainer() {
  const offer = useSelector(offerSelector);
  const agentAvailability = useSelector(getAgentAvailability);
  const phones = concatPhones(offer) || [];
  const isAgentAvailable = agentAvailability && agentAvailability.available;

  if (!agentAvailability || isAgentAvailable) {
    return null;
  }

  const { availableFrom, vacationTo } = agentAvailability;

  return (
    <DescriptionFormatter
      callAt={vacationTo || availableFrom || ''}
      isVacation={!!vacationTo}
      additions={phones.map((p, i) => (
        <span key={p + i}>
          <a className={styles['phone']} href={`tel:${p}`}>
            {p}
          </a>
          {i !== phones.length - 1 ? ', ' : ''}
        </span>
      ))}
    />
  );
}
